import React from 'react';
import SnakImg from '../assets/images/new_main/img-snak-big.png'; // 이미지 경로는 실제 경로로 수정하세요

const formatDate = (yyyymmdd) => {
  return `${yyyymmdd.slice(2, 4)}.${yyyymmdd.slice(4, 6)}.${yyyymmdd.slice(6, 8)}`;
};

const SnackList = ({ data }) => {
  // 날짜별로 그룹화
  const groupedData = data.reduce((acc, item) => {
    if (!acc[item.yyyymmdd]) {
      acc[item.yyyymmdd] = [];
    }
    acc[item.yyyymmdd].push(item);
    return acc;
  }, {});

  // 날짜를 내림차순으로 정렬 (최근 날짜가 먼저)
  const sortedDates = Object.keys(groupedData).sort((a, b) => b.localeCompare(a));

  return (
    <>
      {sortedDates.map((date) => {
        // 각 날짜 내부는 idx 오름차순 정렬
        const items = groupedData[date].sort((a, b) => a.idx - b.idx);
        return (
          <div className='list-box' key={date}>
            <div className='section-title'>{formatDate(date)}</div>
            {items.map((item) => (
              <div className='item' key={item.idx}>
                <img src={SnakImg} alt='snak-icon' width={36} height={29} />
                <div className='item-info'>
                  <span>{item.itemTitle ?? '간식 충전소'}</span>
                  <span>{item.itemName ?? '낮잠 깬 냥냥타임'}</span>
                </div>
                <span className={`delta ${item.delta > 0 ? 'plus' : 'minus'}`}>
                  {item.delta > 0 ? `+${item.delta}` : item.delta}
                </span>
              </div>
            ))}
          </div>
        );
      })}
    </>
  );
};

export default SnackList;
